import { ImageCombinedProps } from './types';

const usePresenter = (props: ImageCombinedProps): ImageCombinedProps => {
  return props;
};

export default usePresenter;
